import { SelectedProductData } from "common/components/ProductChooser";
import { useIntl } from "react-intl";
import { FbaV3ProductErrorLabels } from "./FbaV3ProductErrorLabels";
import { FBA_V3_MAX_QUANTITY_IN_CASE } from "../commons/FbaV3Constants";

export const getFbaV3ProductError = (
  selectedProduct: SelectedProductData,
  formatMessage: ReturnType<typeof useIntl>["formatMessage"]
): string | undefined => {
  const { qty } = selectedProduct;

  if (!!qty && qty > FBA_V3_MAX_QUANTITY_IN_CASE) {
    return formatMessage(FbaV3ProductErrorLabels.skuQuantityExceeded, {
      maxUnitsOfSku: FBA_V3_MAX_QUANTITY_IN_CASE,
    });
  }

  return undefined;
};
